export const capitalize = <T extends string>(text: T): Capitalize<T> =>
  (text.charAt(0).toUpperCase() + text.substring(1)) as Capitalize<T>;

export const toStringOrUndefined = (data: unknown): string | undefined => {
  if (typeof data === 'string') {
    return data;
  }
  return undefined;
};
